import { flux } from 'singletons';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import deepClone from 'utils/deepClone';
import { compile } from 'utils/searchURLs';
import { useI18n } from '~/stores/i18n';

export type SearchNavDescriptor = { to: string; replace?: boolean };

const addDefaultArgumentsDecorator = (
  wrapped: (
    filters: any,
    args: { filtersToAdd: any[]; replace?: boolean },
  ) => SearchNavDescriptor,
) => {
  return ({ filtersToAdd, replace = false }): SearchNavDescriptor => {
    const filters = flux.stores.FiltersStore.getFilters();
    return wrapped(filters, { filtersToAdd, replace });
  };
};

const getExtraParams = (loc: Location) => {
  const currentSearchParams = new URLSearchParams(loc.search);
  let extraSearchParams;
  if (currentSearchParams.has('company')) {
    extraSearchParams = new URLSearchParams({
      company: currentSearchParams.get('company') as string,
    });
  }
  return extraSearchParams;
};

function routeToSearchURL(
  filters,
  { filtersToAdd, replace = false },
): SearchNavDescriptor {
  const newFilters = deepClone(filters);

  filtersToAdd.forEach((filterToAdd) => {
    const index = newFilters.activeFilters.findIndex(
      (filter) => filter.uid === filterToAdd.uid,
    );

    if (index === -1) {
      newFilters.activeFilters.push(filterToAdd);
    } else {
      newFilters.activeFilters[index] = filterToAdd;
    }
  });

  newFilters.page = 1;

  // Remove filters without a value
  newFilters.activeFilters = newFilters.activeFilters.filter(
    (activeFilter) =>
      activeFilter.subOptions.length > 0 || activeFilter.value !== '',
  );

  const loc = window.location;
  const extraParams = getExtraParams(loc as any);
  const searchPath = loc.pathname.includes('/experiences/')
    ? '/experiences'
    : '/s';
  const [path, query] = compile(
    newFilters.country,
    newFilters.city,
    newFilters.page,
    newFilters.activeFilters,
    extraParams,
  ).split('?');
  const pathWithLangCode = generatePathnameWithLangCode(
    `${searchPath}${path}`,
    useI18n.getState().lang,
  );
  const redirectURL = query ? `${pathWithLangCode}?${query}` : pathWithLangCode;

  return { to: redirectURL, replace };
}

export default addDefaultArgumentsDecorator(routeToSearchURL);
